import axios from "axios";
import config from "../config";

export const axiosInstanceSympl = axios.create({
  baseURL: config.url.URL_SYMPL,
  headers: {
    "X-Device-Name": "webapp-retour",
    "X-App-Version": 24,
    "X-Token": "63438565e82fe93cc3cbd7d1eed40e06eb0b1560fe4b7f0c2886d09df11d273f"
  }
});

export const axiosInstanceStock = axios.create({
  baseURL: config.url.URL_STOCK
});
